import { MyIntegerEnum } from './enum'

export const ConferenciaStatus = {
  Aprovado: MyIntegerEnum.create(0, 'Aprovado'),
  Reprovado: MyIntegerEnum.create(1, 'Reprovado'),
  Concluida: MyIntegerEnum.create(2, 'Concluída'),
}
